import { Box } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import AddReportSignatureKeyDialog from "components/settings/report-signature-keys/AddReportSignatureKeyDialog";
import ReportSignatureKeyResultModal from "components/settings/report-signature-keys/ReportSignatureKeyResultModal";
import ReportSignatureKeysTable from "components/settings/report-signature-keys/ReportSignatureKeysTable";
import { useSignatureKeyActionResult } from "components/settings/report-signature-keys/useSignatureKeyActionResult";
import { AUTH_SIGNATURE_KEY_CREATE } from "domain/authority";
import { ReportSignatureKey } from "domain/reportSignatureKeys";
import { reportSignatureKeyService } from "services/report/erasure/ReportSignatureKeyService";
import { hasTenantCookie } from "services/tenants/tenantCookieService";
import { userSessionService } from "services/user/UserSessionService";

const ReportSignatureKeysSettings = () => {
    const { t } = useTranslation();
    const [counter, setCounter] = React.useState(0);
    const [keys, setKeys] = React.useState<ReportSignatureKey[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [requestFailureMessage, setRequestFailureMessage] = React.useState<string | undefined>(undefined);

    const onChange = () => setCounter((prevCount) => prevCount + 1);
    const { result, showResult, hideResult } = useSignatureKeyActionResult(onChange);

    React.useEffect(() => {
        const abortController = new AbortController();
        setLoading(true);
        reportSignatureKeyService
            .fetchKeys(abortController)
            .then((fetchedKeys) => {
                setKeys(fetchedKeys);
                setRequestFailureMessage(undefined);
            })
            .catch(() => {
                if (!abortController.signal.aborted) {
                    setRequestFailureMessage(t("ReportSignatureKeys.table.requestFailed"));
                }
            })
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            });
        return () => abortController.abort();
    }, [counter]);

    return (
        <Box columnLayout>
            <ReportSignatureKeysTable
                keys={keys}
                loading={loading}
                failureMessage={requestFailureMessage}
                onKeyChange={onChange}
                showResult={showResult}
            />
            {!hasTenantCookie() && userSessionService.userHasAllAuthorities([AUTH_SIGNATURE_KEY_CREATE]) && (
                <Box paddingTop={"Xs"}>
                    <AddReportSignatureKeyDialog existingNames={keys.map((key) => key.name)} showResult={showResult} />
                </Box>
            )}
            <ReportSignatureKeyResultModal result={result} onClose={hideResult} />
        </Box>
    );
};

export default ReportSignatureKeysSettings;
